import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CursorSelected icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CursorSelected } from '@sravni/design-system-icons'
 *
 * <CursorSelected />
 * ```
 */
var CursorSelected = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CursorSelected", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6.295 9.166H3.334c-.921 0-1.667-.745-1.667-1.666V3.333c0-.92.746-1.667 1.667-1.667h13.333c.92 0 1.667.746 1.667 1.667V7.5c0 .92-.746 1.666-1.667 1.666H8.795", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.796 10.833v-3.75a1.25 1.25 0 0 0-2.5 0v6.25l-.751-.75a1.295 1.295 0 0 0-1.993 1.633L5.8 17.59c.309.465.83.743 1.387.743h4.407c.84 0 1.55-.626 1.654-1.46l.452-3.614c.11-.89-.501-1.708-1.385-1.852l-3.52-.574v0ZM15.417 4.583l-2.083 2.083-1.25-1.25", stroke: "currentColor", strokeWidth: "1.4", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CursorSelected };
//# sourceMappingURL=CursorSelected.js.map
